import TablesSettings from "../components/settings/TablesSettings";
import { useSettingsStore } from "../stores/settings";
import Templates from "../components/settings/choiceSettings.tsx/Templates";
import ClientText from "../components/settings/choiceSettings.tsx/ClientText";
import Recrutement from "../components/settings/choiceSettings.tsx/Recrutement";
import GuideSocial from "../components/settings/choiceSettings.tsx/GuideSocial";
import {
  ActionButton,
  PageHeader,
  PagePanel,
  PageShell,
} from "../components/ui/page/PageShell";

const Settings = () => {
  const { tabSettings, setTabSettings } = useSettingsStore();

  return (
    <PageShell>
      <PageHeader
        eyebrow="Configuration"
        title={tabSettings !== "" ? tabSettings : "Paramètres"}
        description={
          tabSettings === ""
            ? "Modèles de documents, contenus clients et guides."
            : undefined
        }
        actions={
          tabSettings !== "" ? (
            <ActionButton
              onClick={() => setTabSettings("")}
              icon={
                <svg
                  aria-hidden="true"
                  className="size-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2.2}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
              }
            >
              Retour
            </ActionButton>
          ) : null
        }
      />

      <PagePanel>
        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
          {tabSettings === "" ? (
            <TablesSettings />
          ) : tabSettings === "Templates" ? (
            <Templates />
          ) : tabSettings === "Informations direction" ? (
            <ClientText />
          ) : tabSettings === "Recrutement" ? (
            <Recrutement />
          ) : tabSettings === "Guide social" ? (
            <GuideSocial />
          ) : (
            <TablesSettings />
          )}
        </div>
      </PagePanel>
    </PageShell>
  );
};

export default Settings;
